import * as React from "react";
import BicicleteriaEspecificaContainer from "../containers/bicicleteria-especifica-container";

export default function BicicleteriaEspecificaPage() {
  return <BicicleteriaEspecificaContainer></BicicleteriaEspecificaContainer>;
}
